import api from "services/api";

// Get all tasks
export const getTasks = async () => {
  return api.get("/v1/api/tasks/get");
};

// Get tasks with query params (project_id, assigned_to)
export const getTasksWithParams = async (params) => {
  return api.get("/v1/api/tasks/get", { params });
};

// Get top 10 priority tasks (not done yet, sorted by due date & priority)
export const getTopPriorityTasks = async (params) => {
  return api.get("/v1/api/tasks/top-priority", { params });
};

// Create a new task
// Create a new task
export const createTask = async (taskData, config = {}) => {
  return api.post("/v1/api/tasks/create", taskData, config);
};

// Update a task
export const updateTask = async (taskId, taskData) => {
  return api.patch(`/v1/api/tasks/update/${taskId}`, taskData);
};

// Update task status
export const updateTaskStatus = async (taskId, statusData) => {
  return api.post(`/v1/api/tasks/update-status/${taskId}`, statusData);
};

export const createTaskReview = async (taskId, reviewData) => {
  return api.post(`/v1/api/tasks/review/${taskId}`, reviewData);
};

// Delete a task
export const deleteTask = async (taskId) => {
  return api.delete(`/v1/api/tasks/delete/${taskId}`);
};

export const getEmployeeTaskDateRanges = async (employeeId) => {
  return api.get(`/v1/api/tasks/date-ranges/${employeeId}`);
};

// Get team tasks (tasks assigned to reportees in org tree)
export const getTeamTasks = async (params) => {
  return api.get("/v1/api/tasks/team-tasks", { params });
};

// Task Groups (Mother Tasks)
export const getTaskGroups = async (params) => {
  return api.get("/v1/api/task-groups/get", { params });
};

export const getTaskGroupById = async (params) => {
  return api.get("/v1/api/task-groups/get-by-id", { params });
};

export const createTaskGroup = async (groupData) => {
  return api.post("/v1/api/task-groups/create", groupData);
};

export const groupAndSequenceTasks = async (data) => {
  return api.post("/v1/api/task-groups/group-and-sequence", data);
};

export const updateTaskGroup = async (groupData) => {
  return api.post("/v1/api/task-groups/update", groupData);
};

export const deleteTaskGroup = async (groupData) => {
  return api.post("/v1/api/task-groups/delete", groupData);
};

export const reorderGroupTasks = async (data) => {
  return api.post("/v1/api/task-groups/reorder-tasks", data);
};


export const getTaskGroupReport = async (reportData) => {
  return api.post("/v1/api/reports/task-groups", reportData);
};

// Task Dependencies
export const linkTaskDependency = async (data) => {
  return api.post("/v1/api/tasks/dependencies/link", data);
};

export const unlinkTaskDependency = async (data) => {
  return api.post("/v1/api/tasks/dependencies/unlink", data);
};

export const getTaskDependencies = async (taskId) => {
  return api.get(`/v1/api/tasks/${taskId}/dependencies`);
};


